import { GridTitleWrapper } from './MortgageResult.styles'

export const mortgagesColumns = [
  {
    name: 'APR',
    header: () => <GridTitleWrapper>APR /</GridTitleWrapper>,
    defaultFlex: 2,
    type: 'text',
    render: ({ data }: any) => data.APR,
  },
  {
    name: 'Eligible',
    header: () => <GridTitleWrapper>Eligible/</GridTitleWrapper>,
    defaultFlex: 2,
    type: 'text',
    render: ({ data }: any) => data.Eligible,
  },
  {
    name: 'ExclusiveProduct',
    header: () => <GridTitleWrapper>ExclusiveProduct /</GridTitleWrapper>,
    defaultFlex: 2,
    type: 'text',
    render: ({ data }: any) => data.ExclusiveProduct,
  },
  {
    name: 'FixPayments',
    header: () => <GridTitleWrapper>FixPayments /</GridTitleWrapper>,
    defaultFlex: 2,
    type: 'text',
    render: ({ data }: any) => data.FixPayments,
  },
  {
    name: 'AdverseCredit',
    header: () => <GridTitleWrapper>AdverseCredit /</GridTitleWrapper>,
    defaultFlex: 2,
    type: 'text',
    render: ({ data }: any) => data.AdverseCredit,
  },
  {
    name: 'ArrearsSatisfied',
    header: () => <GridTitleWrapper>ArrearsSatisfied/</GridTitleWrapper>,
    defaultFlex: 2,
    type: 'text',
    render: ({ data }: any) => data.ArrearsSatisfied,
  },
  {
    name: 'AssumedStartDate',
    header: () => <GridTitleWrapper>AssumedStartDate/</GridTitleWrapper>,
    defaultFlex: 2,
    type: 'text',
    render: ({ data }: any) => data.AssumedStartDate,
  },
  {
    name: 'BankruptciesDischarged',
    header: () => <GridTitleWrapper>BankruptciesDischarged/</GridTitleWrapper>,
    defaultFlex: 2,
    type: 'text',
    render: ({ data }: any) => data.BankruptciesDischarged,
  },
  {
    name: 'Cashback',
    header: () => <GridTitleWrapper>Cashback/</GridTitleWrapper>,
    defaultFlex: 2,
    type: 'text',
    render: ({ data }: any) => data.Cashback,
  },
]
